export const USER_IDENTITY_PLATFORM: UserIdentity = 'platform';

export const USER_IDENTITY_MICROSOFT: UserIdentity = 'microsoft';

export type UserIdentity = 'platform' | 'microsoft';
